import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Http, ResponseContentType } from '@angular/http';
import { Store } from '@ngrx/store';
import { AssessmentAnswerInterface } from 'app/assessment/models';
import { AppStateInterface } from 'app/core/app-config/state/models';
import { EntityConnectorInterface } from 'app/core/connector-services/entity-connector-service.interface';
import { RestConnectorService } from 'app/core/connector-services/rest-connector-service/rest-connector-service.abstract';
import { EquipmentCategoryInterface } from 'app/equipment/models/equipment-category.model';
import { EquipmentInterface } from 'app/equipment/models/equipment.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  EmployeeEquipmentInterface,
  EmployeeEquipmentWorkflowInterface,
  EmployeeEquipmentWorkflowStatusInterface,
  EmployeeEquipmentWorkflowStatusTypeInterface } from '../models';

@Injectable({
  providedIn: 'root',
})
export class EquipmentRestConnectorService extends RestConnectorService implements EntityConnectorInterface<EquipmentInterface> {

  constructor(private readonly _httpClient: HttpClient,
              protected readonly _store: Store<AppStateInterface>,
              private readonly _http: Http) {
    super(_store);
  }

  /////////// Unused/deprecated ///////////////

  public loadAll(): Observable<EquipmentInterface[]> {
    return this._httpClient.get<EquipmentInterface[]>(
      '/api/equipment',
      { observe: 'response' },
    )
    .pipe(
      map((httpResponse: HttpResponse<EquipmentInterface[]>) => httpResponse.body),
    );
  }

  public loadOne(id: number): Observable<EquipmentInterface> {
    throw new Error('Method not implemented.');
  }

  public update(entity: EquipmentInterface): Observable<EquipmentInterface> {
    throw new Error('Method not implemented.');
  }

   /////////// Load methods ///////////////

  public loadLibrary(): Observable<EquipmentCategoryInterface[]> {
    return this._httpClient.get<EquipmentCategoryInterface[]>(
      '/api/equipment',
      { observe: 'response' },
    )
    .pipe(
      map((httpResponse: HttpResponse<EquipmentCategoryInterface[]>) => httpResponse.body),
    );
  }

  public loadWorkAreaList(): Observable<AssessmentAnswerInterface[]> {
    return this._httpClient.get<AssessmentAnswerInterface[]>(
      '/api/equipment/work-area-list',
      { observe: 'response' },
    )
    .pipe(
      map((httpResponse: HttpResponse<AssessmentAnswerInterface[]>) => httpResponse.body),
    );
  }

  public loadEquipmentWorkflowStatusList(): Observable<EmployeeEquipmentWorkflowStatusTypeInterface[]> {
    return this._httpClient.get<EmployeeEquipmentWorkflowStatusTypeInterface[]>(
      '/api/equipment/status-list',
      { observe: 'response' },
    )
    .pipe(
      map((httpResponse: HttpResponse<EmployeeEquipmentWorkflowStatusTypeInterface[]>) => httpResponse.body),
    );
  }

  public loadEmployeeEquipmentWorkflowsForUser(userId: number): Observable<EmployeeEquipmentWorkflowInterface[]> {
    return this._httpClient.get<EmployeeEquipmentWorkflowInterface[]>(
      '/api/users/' + userId + '/equipment',
      { observe: 'response' },
    )
    .pipe(
      map((httpResponse: HttpResponse<EmployeeEquipmentWorkflowInterface[]>) => httpResponse.body),
    );
  }

  public loadEquipmentLibraryItem(equipmentId: number): Observable<EquipmentInterface> {
    return this._httpClient.get<EquipmentInterface>(
      `/api/equipment/${equipmentId}`,
      { observe: 'response' },
    )
    .pipe(
      map((httpResponse: HttpResponse<EquipmentInterface>) => httpResponse.body),
    );
  }

  /////////// Update methods ///////////////
  public updateEquipmentLibraryCategory(categoryToUpdate: EquipmentCategoryInterface): Observable<EquipmentCategoryInterface> {
    return this._httpClient.put<EquipmentCategoryInterface>(
    'api/equipment/categories',
    categoryToUpdate,
    { observe: 'response' },
    )
    .pipe(
      map((httpResponse:  HttpResponse<EquipmentCategoryInterface>) => {
        return <EquipmentCategoryInterface> httpResponse.body;
      }),
    );
  }

  public updateEquipmentLibraryItem(itemToUpdate: EquipmentInterface): Observable<EquipmentInterface> {
    return this._httpClient.put<EquipmentInterface>(
    'api/equipment/',
    itemToUpdate,
    { observe: 'response' },
    )
    .pipe(
      map((httpResponse:  HttpResponse<EquipmentInterface>) => {
        return <EquipmentInterface> httpResponse.body;
      }),
    );
  }

  public updateEmployeeEquipmentItem(itemToUpdate: EmployeeEquipmentWorkflowInterface): Observable<EmployeeEquipmentWorkflowInterface> {
    return this._httpClient.put<EmployeeEquipmentInterface>(
      `/api/users/${itemToUpdate.forUser.id}/equipment/${itemToUpdate.id}/equipment-item`,
      itemToUpdate.equipmentItem,
      { observe: 'response' },
      )
      .pipe(
        map((httpResponse:  HttpResponse<EmployeeEquipmentWorkflowInterface>) => {
          return <EmployeeEquipmentWorkflowInterface> httpResponse.body;
        }),
      );
  }

  public updateEmployeeEquipmentWorkflowStatus(
    workflow: EmployeeEquipmentWorkflowInterface,
    itemToUpdate: EmployeeEquipmentWorkflowStatusInterface): Observable<EmployeeEquipmentWorkflowInterface> {
    return this._httpClient.put<EmployeeEquipmentWorkflowStatusInterface>(
      `/api/users/${workflow.forUser.id}/equipment/${workflow.id}/status/${itemToUpdate.id}`,
      itemToUpdate,
      { observe: 'response' },
      )
      .pipe(
        map((httpResponse:  HttpResponse<EmployeeEquipmentWorkflowInterface>) => {
          return <EmployeeEquipmentWorkflowInterface> httpResponse.body;
        }),
      );
  }

  /////////// Create methods ///////////////

  public createEquipmentLibraryCategory(itemToCreate: EquipmentCategoryInterface): Observable<EquipmentCategoryInterface> {
    return this._httpClient.post<EquipmentCategoryInterface>(
      'api/equipment/categories',
      itemToCreate,
      { observe: 'response' },
    )
    .pipe(
      map((httpResponse: HttpResponse<EquipmentCategoryInterface>) => {
        return <EquipmentCategoryInterface> httpResponse.body;
      }),
    );
  }

  public createEquipmentLibraryItem(itemToCreate: EquipmentInterface): Observable<EquipmentInterface> {
    return this._httpClient.post<EquipmentInterface>(
      'api/equipment/',
      itemToCreate,
      { observe: 'response' },
    )
    .pipe(
      map((httpResponse: HttpResponse<EquipmentInterface>) => {
        return <EquipmentInterface> httpResponse.body;
      }),
    );
  }

  public createUserEquipmentWorkflow(itemToCreate: EmployeeEquipmentWorkflowInterface): Observable<EmployeeEquipmentWorkflowInterface> {
    return this._httpClient.post<EmployeeEquipmentWorkflowInterface>(
      `api/users/${itemToCreate.forUser.id}/equipment`,
      itemToCreate,
      { observe: 'response' },
    )
    .pipe(
      map((httpResponse: HttpResponse<EmployeeEquipmentWorkflowInterface>) => {
        return <EmployeeEquipmentWorkflowInterface> httpResponse.body;
      }),
    );
  }

  public addStatusToWorkflow(
    workflow: EmployeeEquipmentWorkflowInterface,
    statusToAdd: EmployeeEquipmentWorkflowStatusInterface): Observable<EmployeeEquipmentWorkflowInterface> {
    return this._httpClient.post<EmployeeEquipmentWorkflowStatusInterface>(
      `api/users/${workflow.forUser.id}/equipment/${workflow.id}/status`,
      statusToAdd,
      { observe: 'response' },
    )
    .pipe(
      map((httpResponse: HttpResponse<EmployeeEquipmentWorkflowInterface>) => {
        return <EmployeeEquipmentWorkflowInterface> httpResponse.body;
      }),
    );
  }

  /////////// Delete methods ///////////////

  public deleteEquipmentLibraryCategory(categoryToDelete: EquipmentCategoryInterface): Observable<EquipmentCategoryInterface> {
    return this._httpClient.delete(
      `api/equipment/categories/${categoryToDelete.id}`,
      { observe: 'response' },
    ).pipe(
      map((httpResponse: HttpResponse<EquipmentCategoryInterface>) => {
        if (httpResponse.status !== 200) {
          return httpResponse.body;
        }
        return categoryToDelete;
      }),
    );
  }

  public deleteEquipmentLibraryItem(itemToDelete: EquipmentInterface): Observable<EquipmentInterface> {
    return this._httpClient.delete(
      `api/equipment/${itemToDelete.id}`,
      { observe: 'response' },
    ).pipe(
      map((httpResponse: HttpResponse<EquipmentInterface>) => {
        if (httpResponse.status !== 200) {
          return httpResponse.body;
        }
        return itemToDelete;
      }),
    );
  }

  public deleteEquipmentWorkflow(workflowToDelete: EmployeeEquipmentWorkflowInterface): Observable<EmployeeEquipmentWorkflowInterface> {
    return this._httpClient.delete(
      `api/users/${workflowToDelete.forUser.id}/equipment/${workflowToDelete.id}`,
      { observe: 'response' },
    ).pipe(
      map((httpResponse: HttpResponse<EquipmentInterface>) => {
        if (httpResponse.status !== 200) {
          return workflowToDelete;
        }
        return workflowToDelete;
      }),
    );
  }

  /////////// Export methods ///////////////
  public loadExcelExportData(details: number[], exportUrl: string): Observable<{ blob: Blob, fileName: string }> {
    const isPdf: boolean = exportUrl.indexOf('/equipment_pdf') > 0;
    let queryParam: string = '?page=';
    let finalExportUrl: string = exportUrl;
    if(isPdf) {
      const idArray: string[] = details.map((id: number) => id.toString());

      queryParam += idArray && idArray.toString();
      finalExportUrl += queryParam;
    }
    return this._http.post(
      finalExportUrl,
      details,
      { responseType: ResponseContentType.Blob },
    )
    .pipe(
      map((response: any) => {
        const contentType: string = isPdf ?
        'application/pdf' :
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const contentDispositionHeader: any = response.headers.get('Content-Disposition');
        const fileName: string = contentDispositionHeader.split(';')[1].trim().split('=')[1].replace(/"/g, '');
        const blob: Blob = new Blob([(<any>response)._body], { type: contentType });
        return { blob, fileName };
      }),
    );
  }

}
